import React, { useRef, useState } from "react";
import { updateUserProfile } from "../../../graphql/client";
import SignaturePad from "./SignaturePad";
import { WAIVER_TEXT, WAIVER_VERSION } from "./waiverContent";
// Reuse the rebuilt profile-modal look (.uim classes).
import "../UserInfoModal/UserInfoModal.css";

// One-time waiver backfill for members who joined before the signup
// flow collected signatures. Blocking by design (no close button) —
// the dashboard renders it until a signature is on file. Saves through
// the authenticated updateUserProfile mutation, which stores the
// signature set-once and stamps signedAt server-side.
const WaiverModal = ({ defaultName, onSigned }) => {
  const [name, setName] = useState(defaultName || "");
  const canvasRef = useRef(null);
  const [hasDrawn, setHasDrawn] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setError("");
    if (!name.trim()) {
      setError("Please enter your full name.");
      return;
    }
    if (!hasDrawn) {
      setError("Please sign with your finger or mouse to continue.");
      return;
    }
    let signatureDataUrl = "";
    try {
      signatureDataUrl = canvasRef.current.toDataURL("image/png");
    } catch (e) {
      console.warn("Could not export signature:", e);
    }
    setLoading(true);
    try {
      await updateUserProfile({
        waiverSignature: signatureDataUrl || null,
        waiverName: name.trim(),
        waiverVersion: WAIVER_VERSION,
      });
      onSigned();
    } catch (err) {
      setError(
        `Couldn't save your signature (${err.message || err}). Please try again.`
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="user-info-modal-overlay">
      <div className="user-info-modal uim">
        <div className="uim-header">
          <h3 className="uim-title">One quick signature</h3>
        </div>
        <div className="uim-body">
          <p className="uim-description">
            Before you continue, please review and sign our liability waiver.
            You'll only see this once.
          </p>

          <div
            style={{
              maxHeight: 180,
              overflowY: "auto",
              border: "1px solid #d0d6e0",
              borderRadius: 8,
              padding: "10px 12px",
              fontSize: 12.5,
              color: "#3a4150",
              whiteSpace: "pre-wrap",
              marginBottom: 12,
              textAlign: "left",
            }}
          >
            {WAIVER_TEXT}
          </div>

          <div className="uim-field">
            <label htmlFor="waiver-backfill-name">Your full name</label>
            <input
              id="waiver-backfill-name"
              type="text"
              className="uim-input"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="First and last name"
              autoComplete="name"
            />
          </div>

          <SignaturePad canvasRef={canvasRef} onDrawnChange={setHasDrawn} />

          {error && (
            <div className="uim-error" style={{ marginTop: 10 }}>
              {error}
            </div>
          )}
        </div>
        <div className="uim-footer">
          <button
            type="button"
            className="uim-btn uim-btn--primary"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Saving…" : "I agree — sign"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default WaiverModal;
